import type { LucideIcon } from 'lucide-react'
import { Settings, Users } from 'lucide-react'

import { APP_ROUTES } from '@/common/constants'
import { NAVIGATION_COPY } from '@/locales/en'

export type AdviserNavItem = {
    key: string
    label: string
    to: string
    icon: LucideIcon
    ariaLabel: string
}

export const ADVISER_NAV_ITEMS: AdviserNavItem[] = [
    {
        key: 'clients',
        label: NAVIGATION_COPY.adviserDesktop.clients,
        ariaLabel: 'Open adviser clients',
        to: APP_ROUTES.CLIENTS,
        icon: Users,
    },
    {
        key: 'account',
        label: NAVIGATION_COPY.adviserDesktop.account,
        ariaLabel: 'Open adviser account',
        to: APP_ROUTES.ACCOUNT,
        icon: Settings,
    },
]
